const googleMapsUrlPrefix = 'https://www.google.com/maps/search/?api=1&query=';

function appendComma(s, more) {
  if (s) {
    if (more) {
      return `${s}, ${more}`;
    }

    return s;
  }

  return more;
}

export default {
  methods: {
    addrHref(fi) {
      const addr = fi.address;
      if (addr.street && addr.city && addr.state) {
        const s = this.addrString(addr);
        return `${googleMapsUrlPrefix}${encodeURIComponent(s)}`;
      } else if (addr.city) {
        let s = `${fi.name} in ${addr.city}`;
        s += addr.state ? `, ${addr.state}` : '';
        return `${googleMapsUrlPrefix}${encodeURIComponent(s)}`;
      }

      return '';
    },
    addrString(addr) {
      if (!addr) {
        return '';
      }

      let s = appendComma('', addr.street);
      s = appendComma(s, addr.city);
      s = appendComma(s, addr.state);
      return appendComma(s, addr.country);
    },
    youTubeLink(link) {
      if (!link) {
        return null;
      }

      let url;
      try {
        url = new URL(link);
      } catch (err) {
        return null;
      }

      if (url.hostname.match(/youtube\.com/) && url.search) {
        // searchParams is not getting populated for some reason, so have to parse search
        const videoId = url.search.match(/[?&]v=(.+)&?/);
        if (videoId.length > 1) {
          return `https://www.youtube-nocookie.com/embed/${videoId[1]}?rel=0`;
        }
      }

      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/links.js